import { render, staticRenderFns } from "./zhiliuping.vue?vue&type=template&id=2fb87c2c&scoped=true&"
import script from "./zhiliuping.vue?vue&type=script&lang=js&"
export * from "./zhiliuping.vue?vue&type=script&lang=js&"
import style0 from "./zhiliuping.vue?vue&type=style&index=0&id=2fb87c2c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb87c2c",
  null
  
)

export default component.exports